define('core/utils/array/some',[],function () {
    'use strict';

    return function some(arr, callback, that) {
        for (var i = 0; i < arr.length; ++i) {
            if (callback.call(that, arr[i], i, arr))
                return true;
        }

        return false;
    };
});

